import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { initiate } from '@/auth';
import GeoDanmarkApi from '@/api/GeoDanmark';

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

initiate(
  (isAuthenticated, user) => {
    store.commit('setLoading', true);
    if (isAuthenticated) {
      GeoDanmarkApi.getMe(user.access_token)
        .then(user => {
          store.commit('updateUser', user);
          store.commit('setLoading', false);
        })
        .catch(() => {
          localStorage.removeItem('token');
          store.commit('setLoading', false);
        });
    } else {
      if (localStorage.getItem('token')) {
        GeoDanmarkApi.getMe(localStorage.getItem('token'))
          .then(user => {
            store.commit('updateUser', user);
            store.commit('setLoading', false);
          })
          .catch(() => {
            store.commit('setLoading', false);
          });
      } else {
        store.commit('setLoading', false);
      }
    }
  },
  (error) => {
    store.commit('setLoading', false);
    console.log(error);
  }
);

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
